import React, { useState, useEffect, Component } from 'react';
import Clone from 'clone';
import { connect } from 'react-redux'
import { AppSettings } from '../../configs'
import '../../assets/css/tor-template-list.css'
import $ from 'jquery'

import { DatePicker, Select, InputDecimal, DropDownMuti } from '../../components/core';
import { SecureGateRoute, BreadCrumb, DetailBotLogModal, PanelExpand, Loading } from '../../components';
import CustomDialog from '../../components/Notifications/Dialog';
import { useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import SelectMUI from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import moment from 'moment'
import {msg} from '../../components/Notifications/MsgBox';
import ReactTooltip from 'react-tooltip'
import { AdjustmentService } from '../../services';
import { useHistory } from "react-router";
import PanelProductEdit from '../../components/PanelProductEdit';
import formNotificationRightToClaim from './Template/formNotificationRightToClaim'
import formNotificationRightToClaim_C from './Template/formNotificationRightToClaim_C'
import formNotificationRightClaim from './Template/formNotificationRightClaim'
import Storage from '../../configs/Storage'
//import { useParams } from "react-router-dom";
import AdjustmentData from './AdjustmentData';
import UserServices from '../../services/UserServices';

const objAdjustment = {
    adjust_no: null,
    str_adjust_date: "",
    adjust_template:"",
    is_adjust: true,
    amount: 0.00,
    approver_code: "",
    approver_name: "",
    approver_position: "",
    create_by: "",
    create_date: "",
    currency: null,
    department: "",
    email: "",
    explanation: null,
    final_installment_flag: false,
    installment_no: null,
    is_sende_auto: true,
    is_sende_auto_email: '',
    is_sende_informal: false,
    po_contract_no: "",
    po_header_text: "",
    procurement_method: "",
    str_purchase_date: "",
    purchase_no: "",
    remark_adjust_type:"",
    remark_adjust_text:"",
    remark: "",
    str_reserved_adjust_date: "",
    reserved_adjust_no: "",
    reserved_adjust_template: "",
    is_reserved_adjust: false,
    adjustment_id: 0,
    status: null,
    telephone: "",
    update_by: null,
    update_date: "",
    vendor_code: "",
    vendor_name: "",
    product_type:"",
    message_reject:""
}

export default () => {

    let { adjustId } = useParams();
    const history = useHistory();
    const user = Storage.getUser();
    const [stateObjAdjustment, setStateObjAdjustment] = React.useState({});
    const [stateAdjustId, setStateAdjustId] = React.useState({});
    const [openLoading, setOpenLoading] = React.useState(false);
    const [hasAdjustment, setHasAdjustment] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(false);

    const [IsError, setIsError] = React.useState(false);
    const [adjustmentDetailReasons,setAdjustmentDetailReasons] = React.useState([]);
    const [signerPosition,setSignerPosition] = React.useState('');

    const [teplateNotificationRightToClaim,setTeplateNotificationRightToClaim] = React.useState('');
    const [teplateNotificationRightClaim,setTeplateNotificationRightClaim] = React.useState('');

    const [isOpenViewFile,setIsOpenViewFile] = React.useState(false);
    const [isOpenConfirmSend,setIsOpenConfirmSend] = React.useState(false);
    const [isOpenEditAdjustment,setIsOpenEditAdjustment] = React.useState(false);
    

    const [isPrintAdjust,setIsPrintAdjust] = React.useState(false);
    const [isPrintReservedAdjust,setIsPrintReservedAdjust] = React.useState(false);
    const [isOpenConfirmReject,setIsOpenConfirmReject] = React.useState(false);
    const [isOpenConfirmApprove,setIsOpenConfirmApprove] = React.useState(false);
    const [isOpenViewFileComplete,setIsOpenViewFileComplete] = React.useState(false);
    const [hasPrintHeader,setHasPrintHeader] = React.useState(true);
    const [canApprove,setCanApprove] = React.useState(false);

    const [adjustTemplateData,setAdjustTemplateData] = React.useState({
        'date':'',
        'company_name':'',
        'po_contract_no':'',
        'str_purchase_date_th':'',
        'po_header_text':'',
        'approver_name':'',
        'approver_position':'',
        'org_unit':'',
        'org_unit_tel':'',
        'reason':''
    });

    const [reservedAdjustTemplateData,setReservedAdjustTemplateData] = React.useState({
        'date':'',
        'company_name':'',
        'adjust_no':'',
        'str_adjust_date_th':'',
        'str_reserved_adjust_date_th':'',
        'approver_name':'',
        'approver_position':'',
        'org_unit':'',
        'org_unit_tel':'',
        'reason':'',
        'draw':0
    });

    const [showErrorPOContractNo,setShowErrorPOContractNo] = React.useState(false);
    const [showErrorPOContractNoText,setShowErrorPOContractNoText] = React.useState('');

    const [appReadonly,setAppReadonly] = useState(true);

    useEffect(() => {
        setStateObjAdjustment({...objAdjustment});
        setStateAdjustId({...adjustId});
        loadReportMaster(()=>{
            if (adjustId != 0) {
                GetAdjustmentById(adjustId);
            }
        });
      }, [adjustId])

      useEffect(() => {

        console.log('stateObjAdjustment',stateObjAdjustment)
      },[stateObjAdjustment])


      function loadReportMaster(callback) {

        try {

            AdjustmentService.getAdjustmentFormMaster().then((response) => {
                
                if(response.success === true)
                {
                    setAdjustmentDetailReasons(response.data.adjustmentDetailReason);

                    let _signerPosition = "";
                    if(response.data.adjustmentDetailSignerPosition.length > 0)
                    {
                        _signerPosition = response.data.adjustmentDetailSignerPosition[0].display;
                        setSignerPosition(_signerPosition);
                    }

                    if(adjustId === 0 && response.data.adjustmentDetailReason.length > 0){
                        setStateObjAdjustment((previous)=>({
                            ...previous,
                            approver_position: _signerPosition?_signerPosition:previous.approver_position,
                            remark_adjust_type: response.data.adjustmentDetailReason.value,
                            remark_adjust_text: response.data.adjustmentDetailReason.display,
                          }));
                    }
                }

                if(callback)
                {
                    callback()
                }
            })

            
        } catch (e) {
            console.log(e);
            //showMessage("error", "System error.", true);
        }
    }


      function GetAdjustmentById(adjustId) {

        try {
            setOpenLoading(true);
            AdjustmentService.getAdjustmentById(adjustId).then((response) => {
                console.log("getAdjustmentById",response);

                if(response === undefined || response === null || response === '')
                {
                    setOpenLoading(false);
                    msg.error("ไม่พบข้อมูล หรือ ไม่มีสิทธิเปิดรายการหนังสือเกี่ยวข้องกับการปรับ");
                    history.push(`/Adjustment`);

                }else{
                    
                    let obj = Clone(stateObjAdjustment);

                    if(adjustmentDetailReasons.length > 0 && !obj.remark_adjust_type)
                    {
                        obj.remark_adjust_type = adjustmentDetailReasons[0].value;
                        obj.remark_adjust_text = adjustmentDetailReasons[0].display;
                    }

                    setCanApprove((response.isReadonly === false && response.status === 'WAITFAPP' && response.current_employeeId === user.userName))
                
                    let adjust_template = response.adjust_template ?? "";
                    let reserved_adjust_template = response.reserved_adjust_template ?? "";
                    if((response.status === '' || response.status === 'DRAFT'|| response.status === 'REJECT') == false || response.isReadonly === true)
                    {
                         adjust_template = adjust_template.replace(/contenteditable="true"/g, 'contenteditable="false"');
                         reserved_adjust_template = reserved_adjust_template.replace(/contenteditable="true"/g, 'contenteditable="false"');

                         adjust_template = adjust_template.replace(/<span style="padding-left: 80px;">/g, '<span style="padding-left: 80px;" contenteditable="false">');
                         reserved_adjust_template = reserved_adjust_template.replace(/<span style="padding-left: 80px;">/g, '<span style="padding-left: 80px;" contenteditable="false">');
                        
                        adjust_template = adjust_template.split('A4 water-mark water-mark-ie').join('A4 water-mark water-mark-ie allTextColorBlack');
                        reserved_adjust_template = reserved_adjust_template.split('A4 water-mark water-mark-ie').join('A4 water-mark water-mark-ie allTextColorBlack');

                        if(response.status === 'COMPLETE' )
                        {
                            adjust_template = adjust_template.replace("water-mark","").replace("water-mark-ie","");
                            reserved_adjust_template = reserved_adjust_template.replace("water-mark","").replace("water-mark-ie","");
                        }

                    }
                    setTeplateNotificationRightToClaim(adjust_template); 
                    setTeplateNotificationRightClaim(reserved_adjust_template);

                    console.log('response', response)

                    setStateObjAdjustment({
                        ...obj,
                        adjust_no: response.adjust_no,
                        str_adjust_date: checkYear(response.adjust_date), //response.adjust_date ? moment(response.adjust_date).format('DD/MM/YYYY'): "",
                        adjust_template: response.adjust_template,
                        is_adjust: response.is_adjust,
                        amount: setFormateMomey(response.amount),
                        approver_code: response.approver_code,
                        approver_name: response.approver_name,
                        approver_position: response.approver_position,
                        create_by: response.create_by,
                        create_date: response.create_date,
                        currency: response.currency,
                        department: response.department,
                        email: response.email,
                        explanation: response.explanation,
                        final_installment_flag: response.final_installment_flag,
                        installment_no: response.installment_no,
                        is_sende_auto: response.is_sende_auto,
                        is_sende_auto_email: response.is_sende_auto_email,
                        is_sende_informal: response.is_sende_informal,
                        po_contract_no: response.po_contract_no,
                        po_header_text: response.po_header_text,
                        procurement_method: response.procurement_method,
                        str_purchase_date: checkYear(response.purchase_date), //response.purchase_date ? moment(response.purchase_date).format('DD/MM/YYYY'): "",
                        purchase_no: response.purchase_no,
                        remark: response.remark,
                        str_reserved_adjust_date: checkYear(response.reserved_adjust_date), //response.reserved_adjust_date ? moment(response.reserved_adjust_date).format('DD/MM/YYYY'): "",
                        reserved_adjust_no: response.reserved_adjust_no,
                        reserved_adjust_template: response.reserved_adjust_template ,
                        is_reserved_adjust: response.is_reserved_adjust,
                        adjustment_id: response.adjustment_id,
                        status: response.status,
                        status_name: response.status_name,
                        telephone: response.telephone,
                        update_by: response.update_by,
                        update_date: response.update_date,
                        vendor_code: response.vendor_code,
                        vendor_name: response.vendor_name,
                        product_type: response.product_type,
                        remark_adjust_type: response.remark_adjust_type,
                        remark_adjust_text: response.remark_adjust_text,
                        remark_adjust_des: response.remark_adjust_des,
                        message_reject: response.message_reject,
                        isReadonly: response.isReadonly
                    })
                    setOpenLoading(false);
                    
                    if(response.isReadonly)
                    {
                        setHasAdjustment(false);
                    }else{
                        setHasAdjustment(response.status === 'DRAFT' || response.status === 'REJECT');
                    }
                    

                    setTimeout(()=>{
                        setAdjustTemplateData((previous)=>({...previous,
                            'date': toDateStringThai(response.adjust_date),
                            'company_name':response.vendor_name,
                            'po_contract_no':response.po_contract_no,
                            'str_purchase_date_th':toDateStringThai(response.purchase_date),
                            'po_header_text':response.po_header_text,
                            'approver_name':response.approver_name,
                            'approver_position':signerPosition ?? response.approver_position,
                            'org_unit':response.department,
                            'org_unit_tel':response.telephone,
                            'reason': response.remark_adjust_type !== 'OTHER'? response.remark_adjust_text : response.remark_adjust_des
                        }))

                        setReservedAdjustTemplateData((previous)=>({...previous, 
                            'date': toDateStringThai(response.reserved_adjust_date),
                            'company_name':response.vendor_name,
                            'adjust_no': response.adjust_no ? response.adjust_no : toBoolean(response.is_adjust) ? response.adjust_no_temp : '',
                            'str_adjust_date_th':toDateStringThai(response.adjust_date),
                            'approver_name':response.approver_name,
                            'approver_position':signerPosition ?? response.approver_position,
                            'org_unit':response.department,
                            'org_unit_tel':response.telephone
                        }))
                    },800)

                       


                }
                
            })
            
        } catch (e) {
            console.log(e);
            setOpenLoading(false);
            //showMessage("error", "System error.", true);
        }
    }

    const handleSearch = (event) => {
        if((stateObjAdjustment.po_contract_no ?? "") === "")
        {
            setShowErrorPOContractNo(true)
            setShowErrorPOContractNoText('กรุณาระบุ PO/Contract No.');
        }
        else if((stateObjAdjustment.po_contract_no ?? "").length === 10)
        {
            setShowErrorPOContractNo(false)

            SearchPoContractNo(stateObjAdjustment.po_contract_no);
        }else{
            setShowErrorPOContractNo(true)
            setShowErrorPOContractNoText('PO/Contract No. ไม่ถูกต้อง');
        }
    };

    function SearchPoContractNo(poContractNo) {

        try {
            setShowErrorPOContractNo(false)
            setOpenLoading(true);
            AdjustmentService.searchPoContractNo(poContractNo).then((response) => {
            
                if(response.po_contract_no)
                {
                    let obj = Clone(stateObjAdjustment);

                    let adjust_template = (response.product_type === 'C' ? formNotificationRightToClaim_C.template : formNotificationRightToClaim.template).replace('{#approver_position}',signerPosition ?? response.approver_position );
                    let reserved_adjust_template = (formNotificationRightClaim.template).replace('{#approver_position}',signerPosition ?? response.approver_position );

                    setTeplateNotificationRightToClaim(adjust_template);
                    setTeplateNotificationRightClaim(reserved_adjust_template)



                    if(adjustmentDetailReasons.length > 0 && !obj.remark_adjust_type)
                    {
                        obj.remark_adjust_type = adjustmentDetailReasons[0].value;
                        obj.remark_adjust_text = adjustmentDetailReasons[0].display;
                    }
                 
                    setAdjustTemplateData((previous)=>({...previous,
                        'company_name': response.vendor_name,
                        'po_contract_no': response.po_contract_no,
                        'str_purchase_date_th': toDateStringThai(response.str_purchase_date),
                        'po_header_text': response.po_header_text,
                        'approver_name': response.approver_name,
                        'approver_position': signerPosition ?? response.approver_position,
                        'org_unit': response.department,
                        'org_unit_tel': response.telephone,
                        'reason': response.remark_adjust_type !== 'OTHER'? response.remark_adjust_text : response.remark_adjust_des
                    }))

                    setReservedAdjustTemplateData((previous)=>({...previous, 
                        'company_name':response.vendor_name,
                        'adjust_no': response.adjust_no ? response.adjust_no : toBoolean(response.is_adjust) ? response.adjust_no_temp : '',
                        'str_adjust_date_th':'',
                        'str_reserved_adjust_date_th':toDateStringThai(response.str_reserved_adjust_date),
                        'approver_name':response.approver_name,
                        'approver_position':signerPosition ?? response.approver_position,
                        'org_unit':response.department,
                        'org_unit_tel':response.telephone
                    }))
    
                    console.log('setReservedAdjustTemplateData',{
    
                        'company_name':response.vendor_name,
                        'adjust_no': response.adjust_no ? response.adjust_no : toBoolean(response.is_adjust) ? response.adjust_no_temp : '',
                        'str_adjust_date_th':'',
                        'str_reserved_adjust_date_th':toDateStringThai(response.str_reserved_adjust_date),
                        'approver_name':response.approver_name,
                        'approver_position':signerPosition ?? response.approver_position,
                        'org_unit':response.department,
                        'org_unit_tel':response.telephone
                    })
                    setStateObjAdjustment({
                        ...obj,
                        adjust_no: response.adjust_no,
                        str_adjust_date: checkYear(response.adjust_date), // response.adjust_date ? moment(response.adjust_date).format('DD/MM/YYYY'): "",
                        adjust_template: adjust_template,
                        is_adjust: response.is_adjust,
                        amount: setFormateMomey(response.amount),
                        approver_code: response.approver_code,
                        approver_name: response.approver_name,
                        approver_position: signerPosition ?? response.approver_position,
                        create_by: response.create_by,
                        create_date: response.create_date,
                        currency: response.currency,
                        department: response.department,
                        email: response.email,
                        explanation: response.explanation,
                        final_installment_flag: response.final_installment_flag,
                        installment_no: response.installment_no,
                        is_sende_auto: response.is_sende_auto,
                        is_sende_auto_email: response.is_sende_auto_email,
                        is_sende_informal: response.is_sende_informal,
                        po_contract_no: response.po_contract_no,
                        po_header_text: response.po_header_text,
                        procurement_method: response.procurement_method,
                        str_purchase_date: checkYear(response.purchase_date), //response.purchase_date ? moment(response.purchase_date).format('DD/MM/YYYY'): "" ,
                        purchase_no: response.purchase_no,
                        remark: response.remark,
                        str_reserved_adjust_date: checkYear(response.reserved_adjust_date), //response.reserved_adjust_date ? moment(response.reserved_adjust_date).format('DD/MM/YYYY'): "" ,
                        reserved_adjust_no: response.reserved_adjust_no,
                        reserved_adjust_template: reserved_adjust_template,
                        //is_reserved_adjust: response.is_reserved_adjust,
                        adjustment_id: response.adjustment_id,
                        status: response.status,
                        telephone: response.telephone,
                        update_by: response.update_by,
                        update_date: response.update_date,
                        vendor_code: response.vendor_code,
                        vendor_name: response.vendor_name,
                        adjust_no_temp: response.adjust_no_temp,
                        reserved_adjust_no_temp: response.reserved_adjust_no_temp,
                        product_type: response.product_type,
                        remark_adjust_des: response.remark_adjust_des,
                        isReadonly: response.isReadonly
                    })

                    if(response.isReadonly === true)
                    {
                        setIsEdit(false);
                        setHasAdjustment(false)
                    }else{
                        setIsEdit(true);
                        setHasAdjustment(!(!response.po_contract_no));
                    }
                    
                }else{
                    setShowErrorPOContractNoText('ไม่พบข้อมูล');
                    setShowErrorPOContractNo(true)
                }

                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false);
            //showMessage("error", "System error.", true);
        }
    }

    const toDateStringThai = (txt)=>
    {
        if(txt && txt.length === 10)
        {
            const txts = txt.split('/');
            const date = new Date(parseInt(txts[2]), parseInt(txts[1]) - 1, parseInt(txts[0]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
    
            return result;
        }else if(txt && txt.length === 19)
        {
            const txtTs = txt.split('T');
            const txts = txtTs[0].split('-');
            const date = new Date(parseInt(txts[0]), parseInt(txts[1]) - 1, parseInt(txts[2]))
            const result = date.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })

            return result;
        }
        else{
            return '';
        }
    }
    function checkYear(textdate) {
        let value = textdate
        value = textdate ? moment(textdate).format('DD/MM/YYYY') : ""
        if (moment(value, 'DD/MM/YYYY').isValid()) {
            if(value < "01/01/2000"){
                value = ""
            }
            else{
                value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
            }
        }
        
        return value
    }

    const handleChangeObjAdjustment = (event) => {
        let obj = {};//Clone(stateObjAdjustment);
        const target = event.target
        let value = target.type === 'checkbox' || target.type === 'radio' ? target.checked : target.value
        const name = target.name

        //check date
        if (target.className) {
            if ((target.className.indexOf("js-datepicker") > -1 || target.className.indexOf("js-datepicker-all") > -1) && (value.toString()).indexOf("/") > 0) {
                let dateData = (value.toString()).split("/")
                let dateDataLength = dateData.length
                if (dateDataLength === 3) {
                    if (moment(value, 'DD/MM/YYYY').isValid()) {
                        value = moment(value, 'DD/MM/YYYY').format('DD/MM/YYYY')
                    }
                }
            }
        }


        if (name === "is_sende_informal") {
            if (value == true) {
                obj["is_sende_auto"] = false;
                obj[name] = value;
            }
        }

        if (name === "is_sende_auto") {
            if (value === true) {
                obj["is_sende_informal"] = false;
                obj[name] = value;
            }
        }

        if (name === "remark_adjust_type")
        {
            if (value) {
                const _datas = adjustmentDetailReasons.filter(p=> p.value === value);
                
                if(_datas.length > 0)
                {
                    obj.remark_adjust_text = _datas[0].display;
                }
            }
        }

        // if(name === 'final_installment_flag')
        // {
        //     if (value) {
        //         obj.installment_no = '';
        //     }
        // }

        obj[name] = value;
        console.log('obj',obj)
        
        setStateObjAdjustment((previous)=>({
          ...previous,...obj
        }));

        //console.log("handleChangeObjAdjustment")
        //console.log(obj);


        
        if(name === "str_adjust_date")
        {
            setAdjustTemplateData((previous)=>({...previous,'date':toDateStringThai(value)}))
            setReservedAdjustTemplateData((previous)=>({...previous,'str_adjust_date_th':toDateStringThai(value)}))
        }

        if(name === "str_purchase_date")
        {
            setAdjustTemplateData((previous)=>({...previous,'str_purchase_date_th':toDateStringThai(value)}))
            
        }

        if(name === "telephone")
        {
            setAdjustTemplateData((previous)=>({...previous,'org_unit_tel':value}))
            setReservedAdjustTemplateData((previous)=>({...previous,'org_unit_tel':value}))
        }

        if (name === "remark_adjust_type")
        {
            if (value) {
                const _datas = adjustmentDetailReasons.filter(p=> p.value === value);
                
                if(_datas.length > 0)
                {
                    if(_datas[0].value !== 'OTHER')
                    {
                        setAdjustTemplateData((previous)=>({...previous,'reason': _datas[0].display}))
                    }
                    else{
                        setAdjustTemplateData((previous)=>({...previous,'reason': stateObjAdjustment.remark_adjust_des}))
                    }
                }
            }
        }

        if (name === "remark_adjust_des")
        {
            setAdjustTemplateData((previous)=>({...previous,'reason':value}))
        }

        if(name === "str_reserved_adjust_date")
        {
            setReservedAdjustTemplateData((previous)=>({...previous,'date':toDateStringThai(value)}))
        }

        if(name === "str_reserved_adjust_date")
        {
            setReservedAdjustTemplateData((previous)=>({...previous,'str_reserved_adjust_date_th':toDateStringThai(value)}))
        }

        if(name === "is_reserved_adjust")
        {
            setTimeout(()=>{
                setReservedAdjustTemplateData((previous)=>({...previous,'draw': previous.draw + 1}))
            },300)
            
        }
      };

    const handleTextField = (e, fieldName) => {
        let obj = Clone(stateObjAdjustment);
        obj[fieldName] = e.target.value;
        setStateObjAdjustment({...obj});
    };


    const editChange = (text, fieldName, status) => {
      if (status === "" || status === "DRAFT" || status === "REJECT") {
        console.log("editChange text", text);
        if ((text + "").length > 60) {
          if (fieldName === "adjust_template") {
            setTeplateNotificationRightToClaim(text);
            setStateObjAdjustment((previous) => ({
              ...previous,
              adjust_template: text,
            }));
          }

          if (fieldName === "reserved_adjust_template") {
            setTeplateNotificationRightClaim(text);
            setStateObjAdjustment((previous) => ({
              ...previous,
              reserved_adjust_template: text,
            }));
            setTimeout(() => {
              setReservedAdjustTemplateData((previous) => ({
                ...previous,
                draw: previous.draw + 1,
              }));
            }, 300);
          }

          setStateObjAdjustment((previous) => ({
            ...previous,
            fieldName: text,
          }));
        } else {
          if (fieldName === "adjust_template") {
            if ((teplateNotificationRightToClaim ?? "").length > 60) {
              setTeplateNotificationRightToClaim(
                teplateNotificationRightToClaim
              );
              setStateObjAdjustment((previous) => ({
                ...previous,
                adjust_template: teplateNotificationRightToClaim,
              }));
            } else {
              let adjust_template =
                stateObjAdjustment.product_type === "C"
                  ? formNotificationRightToClaim_C.template
                  : formNotificationRightToClaim.template;

              setTeplateNotificationRightToClaim(adjust_template);
              setStateObjAdjustment((previous) => ({
                ...previous,
                adjust_template: adjust_template,
              }));
            }
          }

          if (fieldName === "reserved_adjust_template") {
            if ((teplateNotificationRightClaim ?? "").length > 60) {
              setTeplateNotificationRightClaim(teplateNotificationRightClaim);
              setStateObjAdjustment((previous) => ({
                ...previous,
                reserved_adjust_template: teplateNotificationRightClaim,
              }));
            } else {
              let reserved_adjust_template =
                formNotificationRightClaim.template;

              setTeplateNotificationRightClaim(reserved_adjust_template);
              setStateObjAdjustment((previous) => ({
                ...previous,
                reserved_adjust_template: reserved_adjust_template,
              }));
            }

            setTimeout(() => {
              setReservedAdjustTemplateData((previous) => ({
                ...previous,
                draw: previous.draw + 1,
              }));
            }, 300);
          }
        }
      }
    };

    const toBoolean = (value) =>{
        if (value === 1)
            return true
        else if (value === true)
            return true
        else
            return false
    }

    const  setFormateMomey = (value) =>{
        const numeral = require('numeral');
        return numeral(value).format("0,0.00")
    }

    function validate() {
        let checkErrors = []
        let isError = false

        if(stateObjAdjustment.is_adjust == false && stateObjAdjustment.is_reserved_adjust == false){
            checkErrors.push({ error_message: "กรุณาระบุ หนังสือเกี่ยวข้องกับการปรับ" })
        }

        console.log('validate', stateObjAdjustment)

        if(stateObjAdjustment.is_adjust == true){
            if((stateObjAdjustment.str_adjust_date ?? "") == ""){
                checkErrors.push({ error_message: stateObjAdjustment.product_type === "C" ? 'กรุณาระบุ วันที่ หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ' : 'กรุณาระบุ วันที่ หนังสือแจ้งสิทธิ์เรียกค่าปรับ' })
            }
            if((stateObjAdjustment.installment_no ?? "") == ""){// && stateObjAdjustment.final_installment_flag !== true){
                checkErrors.push({ error_message: "กรุณาระบุ งวดที่" })
            }
        }


        if(stateObjAdjustment.is_reserved_adjust == true){
            if((stateObjAdjustment.str_reserved_adjust_date ?? "") == ""){
                checkErrors.push({ error_message: "กรุณาระบุ วันที่ หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ" })
            }
            // if(stateObjAdjustment.installment_no == "" && stateObjAdjustment.final_installment_flag !== true){
            //     checkErrors.push({ error_message: "กรุณาระบุ งวดที่" })
            // }
        }

        if(stateObjAdjustment.remark_adjust_type == "OTHER" && (stateObjAdjustment.remark_adjust_des ?? "").trim() == ""){
            checkErrors.push({ error_message: "กรุณาระบุ คำอธิบายเพิ่มเติม" })
        }

        if(stateObjAdjustment.str_purchase_date == ""){
            checkErrors.push({ error_message: "กรุณาระบุ วันที่ ข้อมูลสัญญาหรือข้อตกลง" })
        }

        if(stateObjAdjustment.approver_name == ""){
            checkErrors.push({ error_message: "กรุณาระบุ ชื่อ - นามสกุล ข้อมูลผู้ลงนาม" })
        }
        if(stateObjAdjustment.approver_position == ""){
            checkErrors.push({ error_message: "กรุณาระบุ ตำแหน่ง ข้อมูลผู้ลงนาม" })
        } 

        if(stateObjAdjustment.department == ""){
            checkErrors.push({ error_message: "กรุณาระบุ หน่วยงาน ข้อมูลติดต่อสอบถาม" })
        }
        if(stateObjAdjustment.telephone == ""){
            checkErrors.push({ error_message: "กรุณาระบุ เบอร์โทร ข้อมูลติดต่อสอบถาม" })
        }

        if(stateObjAdjustment.is_sende_auto == false && stateObjAdjustment.is_sende_informal == false){
            checkErrors.push({ error_message: "กรุณาระบุ วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ" })
        }
        
        if(stateObjAdjustment.is_sende_auto == true && !stateObjAdjustment.is_sende_auto_email){
            checkErrors.push({ error_message: "กรุณาระบุ E-mail Vendor" })
        }else if(stateObjAdjustment.is_sende_auto == true && !ValidateEmail(stateObjAdjustment.is_sende_auto_email))
        {
            checkErrors.push({ error_message: "กรุณาระบุ E-mail ตามรูปแบบ Ex: example@ptt.com" })
        }

        let error_messages = []
        if (checkErrors.length > 0) {
            checkErrors.forEach((error) => {
                error_messages.push(error.error_message)
            })
            isError = true
            msg.error(error_messages.join('<br/>'))
        }
        return isError
    }

    const ValidateEmail = (mail) =>
    {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
    {
        return (true)
    }
        return (false)
    }

    const handleSave = (event) => {
        if (validate()) {

        }
        else {
            if (stateObjAdjustment.adjustment_id == 0) {
                saveAdjustment(stateObjAdjustment);
            }
            else {
                updateAdjustment(stateObjAdjustment);
            }
        }
    };

    function saveAdjustment(ObjAdjustment) {

        try {
            setOpenLoading(true);
            AdjustmentService.saveAdjustment(ObjAdjustment).then((response) => {
                console.log("saveAdjustment");
                console.log(response);
                if(response.isSuccess == true){
                    msg.success(response.returnMessage);

                    if(ObjAdjustment.isSubmit !== true)
                    {
                        history.push(`/AdjustmentDetail/${response.transactionNo}`);
                    }else{
                        history.push(`/Adjustment`);
                    }
                    
                }else{
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false);
        }
    }


    
    function updateEditAdjustment(objAdjustment) {

        try {
            setOpenLoading(true);
            AdjustmentService.updateEditAdjustment(objAdjustment).then((response) => {
                console.log("updateEditAdjustment");
                console.log(response);
                setIsOpenEditAdjustment(false)
                if(response.isSuccess == true){
                    msg.success(response.returnMessage);

                    if(objAdjustment.isSubmit !== true)
                    {
                        window.location.reload(true)
                        //history.push(`/AdjustmentDetail/${adjustId}`);
                    }else{
                        history.push(`/Adjustment`);
                    }
                    
                }else{
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
        }
    }

    function updateAdjustment(ObjAdjustment) {

        try {
            setOpenLoading(true);
            AdjustmentService.updateAdjustment(ObjAdjustment).then((response) => {
                console.log("updateAdjustment");
                console.log(response);
                if(response.isSuccess == true){
                    msg.success(response.returnMessage);

                    if(ObjAdjustment.isSubmit === true)
                    {
                        history.push(`/Adjustment`);
                    }
                    
                }
                else{
                    msg.error(response.returnMessage);
                }
                setOpenLoading(false);
            })
        } catch (e) {
            console.log(e);
            setOpenLoading(false);
        }
    }

    function IsShowsLoading(props) {
        const { isLoading } = props;
        return (
            (isLoading ?
                <div id="loading-element">
                    <div id="loading-indicator">
                        <div className="lds-ripple"><div></div><div></div></div>
                    </div>
                </div>
                : null)
        )
    }


    const handleOnClickPreview = () => {
        if(isPrintAdjust === true || isPrintReservedAdjust === true)
        {
            setOpenLoading(true)
            if(isPrintAdjust === true)
            {
            
                if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
                {
                    AdjustmentService.getCreatePDFAdjustmentDetail(adjustId,"adjust",
                    stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameAdjustment_G(stateObjAdjustment.po_contract_no)).then((response)=>{
                        setIsOpenViewFile(false);
                        setOpenLoading(false)
                    });
                }else{
                    let vs = {
                        'date':toDateStringThai(stateObjAdjustment.str_adjust_date)
                        ,'company_name':stateObjAdjustment.vendor_name
                        ,'po_contract_no':stateObjAdjustment.po_contract_no
                        ,'str_purchase_date_th':toDateStringThai(stateObjAdjustment.str_purchase_date)
                        ,'po_header_text':stateObjAdjustment.po_header_text
                        ,'company_name':stateObjAdjustment.vendor_name
                        ,'reason':stateObjAdjustment.remark_adjust_type !== 'OTHER'? stateObjAdjustment.remark_adjust_text : stateObjAdjustment.remark_adjust_des
                        ,'approver_name':stateObjAdjustment.approver_name
                        ,'approver_position':signerPosition ?? stateObjAdjustment.approver_position
                        ,'org_unit':stateObjAdjustment.department
                        ,'org_unit_tel':stateObjAdjustment.telephone
                        ,'no':stateObjAdjustment.adjust_no
                    }

                    const html = stateObjAdjustment.adjust_template;

                    AdjustmentService.getDraftPDFFile({'body':html,
                    'filename':stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameAdjustment_G(stateObjAdjustment.po_contract_no),
                    'values':vs}).then((response)=>{
                        setIsOpenViewFile(false);
                        setOpenLoading(false)
                    });

                }
               
            }else{
                console.log('isPrintAdjust', isPrintAdjust)
            }

            if(isPrintReservedAdjust === true)
            {

                if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
                {
                    AdjustmentService.getCreatePDFAdjustmentDetail(adjustId,"x",
                    //'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ'
                    stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameReservedAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameReservedAdjustment_G(stateObjAdjustment.po_contract_no)
                    ).then((response)=>{
                        setIsOpenViewFile(false);
                        setOpenLoading(false)
                    });
                }else{

                    let vs = {
                        'date':toDateStringThai(stateObjAdjustment.str_reserved_adjust_date)
                        ,'company_name':stateObjAdjustment.vendor_name
                        ,'po_contract_no':stateObjAdjustment.po_contract_no
                        ,'str_purchase_date_th':toDateStringThai(stateObjAdjustment.str_purchase_date)
                        ,'{po_header_text':stateObjAdjustment.po_header_text
                        ,'{company_name':stateObjAdjustment.vendor_name
                        ,'reason':stateObjAdjustment.remark_adjust_type !== 'OTHER'? stateObjAdjustment.remark_adjust_text : stateObjAdjustment.remark_adjust_des
                        ,'approver_name':stateObjAdjustment.approver_name
                        ,'approver_position':signerPosition ?? stateObjAdjustment.approver_position
                        ,'org_unit':stateObjAdjustment.department
                        ,'org_unit_tel':stateObjAdjustment.telephone
                        ,'adjust_no':stateObjAdjustment.adjust_no
                        ,'str_adjust_date_th':toDateStringThai(stateObjAdjustment.str_adjust_date)
                        ,'no':stateObjAdjustment.reserved_adjust_no

                    };
                const html = stateObjAdjustment.reserved_adjust_template;
                
                

                    AdjustmentService.getDraftPDFFile({'body':html,
                    'filename':stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameReservedAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameReservedAdjustment_G(stateObjAdjustment.po_contract_no),
                    'values':vs}).then((response)=>{
                        setIsOpenViewFile(false);
                        setOpenLoading(false)
                    });

                }
            }else{
                console.log('isPrintReservedAdjust', isPrintReservedAdjust)
            }
        }
    }


    
    const handleOnClickPreviewComplete = () => {
        if(isPrintAdjust === true || isPrintReservedAdjust === true)
        {
            setOpenLoading(true)
            if(isPrintAdjust === true)
            {
                //hasPrintHeader
                if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
                {
                    AdjustmentService.getCreatePDFAdjustmentDetail({'id':adjustId,'type':'adjust',
                    'filename':/*'หนังสือแจ้งสิทธิ์เรียกค่าปรับ'*/stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameAdjustment_G(stateObjAdjustment.po_contract_no),
                    'template': hasPrintHeader? 'adjustment':'adjustment_none_header','body':'','title':''}).then((response)=>{
                        setIsOpenViewFileComplete(false);
                        setOpenLoading(false)
                    });
                }
               
            }else{
                console.log('isPrintAdjust', isPrintAdjust)
            }

            if(isPrintReservedAdjust === true)
            {
                if(stateObjAdjustment.status === 'COMPLETE' || stateObjAdjustment.status === "BCFM" || stateObjAdjustment.status === "ACCEPT")
                {
                    AdjustmentService.getCreatePDFAdjustmentDetail({'id':adjustId,'type':'reserved_adjust',
                    'filename':/*'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ'*/stateObjAdjustment.product_type === 'C' ? AdjustmentData.fileNameReservedAdjustment_C(stateObjAdjustment.po_contract_no):AdjustmentData.fileNameReservedAdjustment_G(stateObjAdjustment.po_contract_no),
                    'template':hasPrintHeader? 'adjustment':'adjustment_none_header','body':'','title':''}).then((response)=>{
                        setIsOpenViewFileComplete(false);
                        setOpenLoading(false)
                    });
                }
            }else{
                console.log('isPrintReservedAdjust', isPrintReservedAdjust)
            }
        }
    }
    
    const getDraftPDFFile = ()=>{
        setIsPrintReservedAdjust(false)
        setIsPrintAdjust(false)

        setIsOpenViewFile(true);
     }


     const getDraftPDFFileComplete = ()=>{
        setIsPrintReservedAdjust(false)
        setIsPrintAdjust(false)

        setIsOpenViewFileComplete(true);
     }

     const handleOnClickSendConfirm = ()=>{
        if (validate()) {

        }
        else {
            setIsOpenConfirmSend(true);
        }
     }

    const handleOnClickSend = () =>{

        if (validate()) {

        }
        else {
            const d = {...stateObjAdjustment,
                isSubmit: true
            };

            if (stateObjAdjustment.adjustment_id == 0) {
                saveAdjustment(d);
            }
            else {
                updateAdjustment(d);
            }
        }
    }

    const handleOnClickEdit = () =>{
            const d = {...stateObjAdjustment
            };
                updateEditAdjustment(d);
    }

    const handleOnClickApproveConfirm= ()=> {
        setIsOpenConfirmApprove(true);
    }

    const handleOnClickApprove = () => {
        const _d = {...stateObjAdjustment,
            isSubmit: true,
            status:"APPROVE"
        };
        updateAdjustment(_d);
    }

    const handleOnClickRejectConfirm= ()=> {
        setIsOpenConfirmReject(true);
    }

    const handleOnClickReject = () => {

        setTimeout(() => {
            const d = {...stateObjAdjustment,
                isSubmit: true,
                status:"REJECT"
            };

            if(d.message_reject)
            {
                updateAdjustment(d);
            }
        }, 500);
    }

    const editAdjustment = () => {

        setIsOpenEditAdjustment(true)
    }

    const handleApplicationCheckReadonly = async () =>
        {
            UserServices.ApplicationReadonly().then(response=>{
                if(response.data === false)
                {
                    setAppReadonly(false)
                }
            })
        }

    useEffect(() => {
        handleApplicationCheckReadonly()
    },[])

  
    return (
        
        <div className="tor tor-template-list" >
            <IsShowsLoading isLoading={openLoading} ></IsShowsLoading>
            <SecureGateRoute />

                <div id="main-content">
                    <div className="page-body">
                        <BreadCrumb breadcrumb={[
                            { name: 'RRS Home', url: AppSettings.defaultUrl },
                            { name: 'หนังสือเกี่ยวข้องกับการปรับ', url: 'Adjustment' },
                            { name: '', url: '' }
                        ]}></BreadCrumb>

                        <div className="sp-page-header-panel row">
                            <div className="col-md-5 sp-page-header">
                                <h1 className="sp-page-header1">หนังสือเกี่ยวข้องกับการปรับ</h1>
                            </div>
                        </div>

                        <div className="sp-page-result-container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="rrs-detail-data">
                                        

                                    <Grid container>
                                            <Grid item>
                                                <Typography  color='primary' style={{fontWeight:'bold'}}>Status:&nbsp;</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography style={{color: stateObjAdjustment.status === 'DRAFT' ? '#28a745':
                                                stateObjAdjustment.status === 'WAITFAPP' ? '#28a745':
                                                stateObjAdjustment.status === 'COMPLETE' ? '#28a745':
                                                stateObjAdjustment.status === 'REJECT' ? '#f44336': '#28a745'
                                            }}>{stateObjAdjustment.status_name}</Typography>
                                            </Grid>
                                        </Grid>
                                        <br />
                                    </div>
                                </div>
                            </div>
                            { stateObjAdjustment.status === 'REJECT' &&<div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                        <label className="rrs-label ">เหตุผล : </label>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                            <input
                                                type="text"
                                                id="message_reject"
                                                name="message_reject"
                                                className="form-control"
                                                placeholder="Remark reject"
                                                defaultValue={stateObjAdjustment.message_reject ?? ''}
                                                autoComplete="off"
                                                disabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                        <label className="rrs-label "><span className="required">*</span> PO/Contract No. : </label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                            <input
                                                type="text"
                                                id="po_contract_no"
                                                name="po_contract_no"
                                                className="form-control"
                                                placeholder="ข้อมูล Purchase / Contract Number"
                                                //defaultValue={stateObjAdjustment.po_contract_no ?? ''}
                                                value={stateObjAdjustment.po_contract_no ?? ''}
                                                //onChange={(e) => handleTextField(e, 'po_contract_no')}
                                                //onChange={handleChangeObjAdjustment}
                                                autoComplete="off"
                                                onChange={(e)=>{
                                                    const re = /^[0-9\b]+$/;
                                                    if (e.target.value === '' || re.test(e.target.value)) {
                                                        handleChangeObjAdjustment(e)
                                                    }
                                                }}
                                                //onBlur={handleChangeObjAdjustment}
                                                disabled={adjustId > 0}
                                                maxLength={10}
                                                pattern="[0-9]*"
                                            />
                                            { showErrorPOContractNo && <FormLabel className="Mui-error">{showErrorPOContractNoText}</FormLabel>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    {adjustId === '0' && !appReadonly && <a onClick={handleSearch} style={{ cursor: 'pointer' }}>
                                        <i className="icon bt-search icon-xs" />
                                    </a>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                        <label className="rrs-label ">ชื่องาน : </label>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                            <input
                                                type="text"
                                                id="po_header_text"
                                                name="po_header_text"
                                                className="form-control"
                                                defaultValue={stateObjAdjustment.po_header_text ?? ''}
                                                //value={stateObjAdjustment.po_header_text ?? ''}
                                                onChange={handleChangeObjAdjustment}
                                                disabled={true}
                                                //viewMode={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                        <input
                                            style={{ width: '20px', marginRight: 10, height: '20px' }}
                                            type="checkbox"
                                            key={`is_adjust${stateObjAdjustment.adjust_no}`}
                                            name="is_adjust"
                                            //onChange={()=>{}}
                                            readOnly={true}
                                            id="is_adjust"
                                            //value={toBoolean(stateObjAdjustment.is_adjust)}
                                            checked={toBoolean(stateObjAdjustment.is_adjust)}
                                        />
                                        {stateObjAdjustment.is_adjust}
                                        <label className="rrs-label ">{stateObjAdjustment.product_type === "C" ? 'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ ที่' : 'หนังสือแจ้งสิทธิ์เรียกค่าปรับ ที่'} : </label>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                            <input
                                                type="text"
                                                id="adjust_no"
                                                name="adjust_no"
                                                className="form-control"
                                                disabled={true}
                                                defaultValue={stateObjAdjustment.adjust_no ? stateObjAdjustment.adjust_no : toBoolean(stateObjAdjustment.is_adjust) ? stateObjAdjustment.adjust_no_temp : ''}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                <label className="rrs-label "><span className="required">*</span> วันที่ : </label>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-group">
                                                <DatePicker
                                                    name="str_adjust_date"
                                                    id="str_adjust_date"
                                                    placeholder="dd/mm/yyyy"
                                                    data-date-format="dd/mm/yyyy"
                                                    value={stateObjAdjustment.str_adjust_date ?? ""}
                                                    onChange={handleChangeObjAdjustment}
                                                    onBlur={handleChangeObjAdjustment}
                                                    readOnly={true}
                                                    disabled={!hasAdjustment}
                                                //ref={this.create_date_from_ref}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                <label className="rrs-label "><span className="required">*</span> งวดที่ : </label>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                {/* <TextField
                                                 id="installment_no"
                                                 name="installment_no"
                                                 variant="outlined"
                                                 //className="form-control"
                                                 value={stateObjAdjustment.installment_no}
                                                 autoComplete="off"
                                                 onChange={handleChangeObjAdjustment}
                                                 maxLength={20}
                                                 size="small"
                                                 pattern="[0-9]*"
                                                 disabled={toBoolean(stateObjAdjustment.final_installment_flag) || !hasAdjustment}
                                                /> */}
                                                 <input
                                                    type="text"
                                                    id="installment_no"
                                                    name="installment_no"
                                                    className="form-control"
                                                    //defaultValue={stateObjAdjustment.installment_no}
                                                    value={stateObjAdjustment.installment_no ?? ''}
                                                    autoComplete="off"
                                                    onChange={handleChangeObjAdjustment}
                                                    maxLength={20}
                                                    disabled={!hasAdjustment}
                                                /> 
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label className={`checkboxcontainer rrs-fine-label mb-0`}> งวดสุดท้าย
                                                    <input
                                                        type="checkbox"
                                                        key={`final_installment_flag${stateObjAdjustment.adjust_no}`}
                                                        name="final_installment_flag"
                                                        onChange={handleChangeObjAdjustment}
                                                        id="final_installment_flag"
                                                        checked={toBoolean(stateObjAdjustment.final_installment_flag)}
                                                        disabled={!hasAdjustment}
                                                    />
                                                    <span className="checkboxmark" />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {stateObjAdjustment.product_type === "G" && <div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                    { (stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT') ? (<input
                                            style={{ width: '20px', marginRight: 10, height: '20px' }}
                                            type="checkbox"
                                            key={`is_reserved_adjust${stateObjAdjustment.reserved_adjust_no}`}
                                            name="is_reserved_adjust"
                                            onChange={handleChangeObjAdjustment}
                                            id="is_reserved_adjust"
                                            checked={toBoolean(stateObjAdjustment.is_reserved_adjust)}
                                            disabled={!hasAdjustment}
                                        />) : (<input
                                            style={{ width: '20px', marginRight: 10, height: '20px' }}
                                            type="checkbox"
                                            readOnly={true}
                                            checked={toBoolean(stateObjAdjustment.is_reserved_adjust)}
                                        />)}
                                        <label className="rrs-label ">หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ ที่ : </label>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                            <input
                                                type="text"
                                                id="reserved_adjust_no"
                                                name="reserved_adjust_no"
                                                className="form-control"
                                                disabled={true}
                                                value={!toBoolean(stateObjAdjustment.is_reserved_adjust) ? '' : stateObjAdjustment.reserved_adjust_no ? stateObjAdjustment.reserved_adjust_no : toBoolean(stateObjAdjustment.is_reserved_adjust) ? stateObjAdjustment.reserved_adjust_no_temp ? stateObjAdjustment.reserved_adjust_no_temp : (stateObjAdjustment.po_contract_no + '/200x') : (stateObjAdjustment.po_contract_no + '/200x')}
                                                //defaultValue={stateObjAdjustment.reserved_adjust_no ? stateObjAdjustment.reserved_adjust_no : toBoolean(stateObjAdjustment.is_reserved_adjust) ? stateObjAdjustment.reserved_adjust_no_temp : ''}
                                                //viewMode={true}
                                                onChange={()=>{}}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                <label className="rrs-label ">{toBoolean(stateObjAdjustment.is_reserved_adjust) === true && <span className="required">*</span>} วันที่ : </label>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-group">
                                                <DatePicker
                                                    name="str_reserved_adjust_date"
                                                    id="str_reserved_adjust_date"
                                                    placeholder="dd/mm/yyyy"
                                                    data-date-format="dd/mm/yyyy"
                                                    value={!toBoolean(stateObjAdjustment.is_reserved_adjust) ? '' : stateObjAdjustment.str_reserved_adjust_date ? stateObjAdjustment.str_reserved_adjust_date : ""}
                                                    onChange={handleChangeObjAdjustment}
                                                    onBlur={handleChangeObjAdjustment}
                                                    readOnly={true}
                                                    disabled={!toBoolean(stateObjAdjustment.is_reserved_adjust) || !hasAdjustment}
                                                //ref={this.create_date_from_ref}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>}

                            <div className="row">
                                <div className="col-md-3">
                                    <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                        <label className="rrs-label "><span className="required">*</span> เหตุผลแจ้งปรับ : </label>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                        { (stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT'|| stateObjAdjustment.status === 'REJECT') ? (<FormControl variant="outlined" fullWidth margin="dense" style={{ marginTop: 0 }}>
                                            <SelectMUI
                                                id="adjustmentDetailReason-remark_adjust_type"
                                                name="remark_adjust_type"
                                                value={stateObjAdjustment.remark_adjust_type ?? 'LATE'}
                                                onChange={handleChangeObjAdjustment}
                                                MenuProps={{
                                                    anchorOrigin: { vertical: "bottom", horizontal: "left", },
                                                    transformOrigin: { vertical: "top", horizontal: "left", },
                                                    getContentAnchorEl: null,
                                                }}

                                                disabled={!hasAdjustment}
                                                >
                                                {
                                                adjustmentDetailReasons.map((p,i) => <MenuItem key={'adjustmentDetailReason-item-'+i} value={p.value}>{p.display}</MenuItem>)
                                                }
                                                </SelectMUI>
                                            </FormControl>) : (<input
                                                type="text"
                                                className="form-control"
                                                disabled={true}
                                                defaultValue={stateObjAdjustment.remark_adjust_text}
                                                
                                            />)}
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                <label className="rrs-label "><span className="required">*</span> คำอธิบายเพิ่มเติม : </label>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="remark_adjust_des"
                                                    name="remark_adjust_des"
                                                    className="form-control"
                                                    defaultValue={stateObjAdjustment.remark_adjust_des ?? ''}
                                                    disabled={!hasAdjustment || stateObjAdjustment.remark_adjust_type !== 'OTHER'}
                                                    onBlur={handleChangeObjAdjustment}
                                                    maxLength={250}
                                                    autoComplete="off"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title="ข้อมูลสัญญาหรือข้อตกลง" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingTop: 10, paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">Vendor Name : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="vendor_name"
                                                                        name="vendor_name"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.vendor_name ?? ''}
                                                                        //value={stateObjAdjustment.vendor_name ?? ''}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">Vendor Code : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="vendor_code"
                                                                        name="vendor_code"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.vendor_code ?? ''}
                                                                        //value={stateObjAdjustment.vendor_code ?? ''}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">วิธีการจัดหา : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="procurement_method"
                                                                        name="procurement_method"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.procurement_method ?? ''}
                                                                        //value={stateObjAdjustment.procurement_method ?? ''}
                                                                        readOnly={true}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">เลขที่สัญญา/ใบสั่งซื้อสั่งจ้าง/<br />ข้อตกลงเป็นหนังสือ : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="purchase_no"
                                                                        name="purchase_no"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.purchase_no ?? ''}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        //readOnly={true}
                                                                        disabled={!hasAdjustment}
                                                                        maxLength={50}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> ลงวันที่ : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>

                                                                    <DatePicker
                                                                        name="str_purchase_date"
                                                                        id="str_purchase_date"
                                                                        placeholder="dd/mm/yyyy"
                                                                        data-date-format="dd/mm/yyyy"
                                                                        value={stateObjAdjustment.str_purchase_date
                                                                            ? stateObjAdjustment.str_purchase_date
                                                                            : ""}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        //onBlur={(event) => handleChangeObjAdjustment(event, true)}
                                                                        onBlur={handleChangeObjAdjustment}
                                                                        doctype="*"
                                                                        tagid="adjust.str_purchase_date"
                                                                        readOnly={true}
                                                                        showsdayall={"All"}
                                                                        disabled={!hasAdjustment}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>

                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">จำนวนเงินตามสัญญา : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="amount"
                                                                        name="amount"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.amount}
                                                                        //value={stateObjAdjustment.amount}
                                                                        // onChange={handleChangeSerachConditionModel}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                        style={{textAlign:'right'}}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={1}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">สกุลเงิน : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="currency"
                                                                        name="currency"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.currency}
                                                                        // value={serachConditionModel.PO_CONTRACT_NO}
                                                                        // onChange={handleChangeSerachConditionModel}
                                                                        disabled={true}
                                                                        //viewMode={true}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title="ผู้ลงนาม" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> ชื่อ - นามสกุล : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="approver_name"
                                                                        name="approver_name"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.approver_name ?? ''}
                                                                        //value={stateObjAdjustment.approver_name ?? ''}
                                                                        readOnly={true}
                                                                        disabled={!hasAdjustment}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> ตำแหน่ง : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="approver_position"
                                                                        name="approver_position"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.approver_position ?? ''}
                                                                        //value={stateObjAdjustment.approver_position ?? ''}
                                                                        readOnly={true}
                                                                        disabled={!hasAdjustment}
                                                                        maxLength={150}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title="ติดต่อสอบถาม" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> ชื่อหน่วยงาน : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="department"
                                                                        name="department"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.department ?? ''}
                                                                        //value={stateObjAdjustment.department ?? ''}
                                                                        readOnly={true}
                                                                        disabled={!hasAdjustment}
                                                                        maxLength={150}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> เบอร์โทร : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="telephone"
                                                                        name="telephone"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        defaultValue={stateObjAdjustment.telephone ?? ''}
                                                                        onBlur={handleChangeObjAdjustment}
                                                                        //value={stateObjAdjustment.telephone ?? ''}
                                                                        disabled={!hasAdjustment}
                                                                        maxLength={50}
                                                                        autoComplete="off"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title="วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "><span className="required">*</span> วิธีส่งหนังสือแจ้งสิทธิ์การเรียกค่าปรับ : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <div className="col-auto">
                                                                        <label className={`radiocontainer`}>ระบบส่งอัตโนมัติ
                                                                            <input
                                                                                key={`is_sende_auto${stateObjAdjustment.adjust_no}`}
                                                                                type="radio"
                                                                                name={"is_sende_auto"}
                                                                                checked={toBoolean(stateObjAdjustment.is_sende_auto)}
                                                                                onChange={handleChangeObjAdjustment}
                                                                                disabled={!hasAdjustment || !(stateObjAdjustment.status === '' || stateObjAdjustment.status==='DRAFT')}
                                                                            />

                                                                            <span className="checkmark" />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label ">E-mail Vendor : </label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <input
                                                                        type="text"
                                                                        id="is_sende_auto_email"
                                                                        name="is_sende_auto_email"
                                                                        className="form-control"
                                                                        placeholder=""
                                                                        //value={stateObjAdjustment.is_sende_auto_email}
                                                                        defaultValue={stateObjAdjustment.is_sende_auto_email}
                                                                        onChange={handleChangeObjAdjustment}
                                                                        disabled={!hasAdjustment}
                                                                        maxLength={50}
                                                                        autoComplete="off"
                                                                    />
                                                                    <FormLabel className="Mui-error" style={{fontSize:11}}>กรุณาตรวจสอบความถูกต้อง ว่าเป็น e-mail ที่ผู้ค้าใช้สำหรับติดต่อกับ ปตท. ในนามผู้ค้า</FormLabel>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>

                                                </Grid>
                                                <Grid item md={12} sm={12} xs={12} style={{ width: '100%', pading: 10, display: 'flex' }}>
                                                    <Grid item xs={3}>
                                                        <div className="col-12">
                                                            <div className="rrs-detail-data" style={{ textAlign: "right" }}>
                                                                <label className="rrs-label "></label>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <div className="col-12">
                                                            <div className="form-group">
                                                                <div className="rrs-detail-data" style={{ textAlign: "left" }}>
                                                                    <div className="col-auto">
                                                                        <label className={`radiocontainer`}>ส่งเองนอกระบบ
                                                                            <input
                                                                                key={`is_sende_informal${stateObjAdjustment.adjust_no}`}
                                                                                type="radio"
                                                                                name={"is_sende_informal"}
                                                                                checked={toBoolean(stateObjAdjustment.is_sende_informal)}
                                                                                onChange={handleChangeObjAdjustment}
                                                                                disabled={stateObjAdjustment.isReadonly || !(stateObjAdjustment.status === '' || stateObjAdjustment.status==='DRAFT')}
                                                                            />
                                                                            <span className="checkmark" />
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title={stateObjAdjustment.product_type === "C" ? "แบบฟอร์มหนังสือแจ้งสงวนสิทธิ์การปรับ" : "แบบฟอร์มหนังสือแจ้งสิทธิ์การเรียกค่าปรับ"} titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                                {stateObjAdjustment.adjust_template &&
                                                ((teplateNotificationRightToClaim ?? "").length > 60) && (
                                                    <PanelProductEdit

                                                    //isReadOnly={!(stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT')}
                                                        name="adjust_template"
                                                        id="adjust_template"
                                                        template={teplateNotificationRightToClaim}
                                                        data={adjustTemplateData}
                                                        editChange={(text) => editChange(text, 'adjust_template', stateObjAdjustment.status)}
                                                        viewMode={!(stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT'|| stateObjAdjustment.status === 'REJECT')}
                                                        height={1080}
                                                        >
                                                    </PanelProductEdit>
                                                )}
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>

                            {stateObjAdjustment.product_type === "G" && toBoolean(stateObjAdjustment.is_reserved_adjust) && <div className="row">
                                <div className="col-md-12">
                                    <PanelExpand title="แบบฟอร์มหนังสือแจ้งสงวนสิทธิ์การปรับ" titleStyle={{ fontWeight: '100', color: '#004290', fontSize: 16 }} divStyle={{ paddingBottom: 10 }}>
                                        <React.Fragment>
                                            <Grid container justifyContent="center" style={{ height: '100%' }}>
                                               
                                                {toBoolean(stateObjAdjustment.is_reserved_adjust) &&
                                                stateObjAdjustment.reserved_adjust_template && 
                                                ((teplateNotificationRightClaim ?? "").length > 60) &&
                                                (
                                                    <PanelProductEdit
                                                        //isReadOnly={!(stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT')}
                                                        name="reserved_adjust_template"
                                                        id="reserved_adjust_template"
                                                        template={teplateNotificationRightClaim}
                                                        data={reservedAdjustTemplateData}
                                                        editChange={(text) => editChange(text, 'reserved_adjust_template', stateObjAdjustment.status)}
                                                        viewMode={!(stateObjAdjustment.status === '' || stateObjAdjustment.status === 'DRAFT'|| stateObjAdjustment.status === 'REJECT')}
                                                        height={1080}
                                                        >
                                                        
                                                    </PanelProductEdit>
                                                )}
                                            </Grid>
                                        </React.Fragment>
                                    </PanelExpand>
                                </div>
                            </div>
                            }
                            




                            <div className="rrs-detail py-1">
                                <div className="row sp-table-content-footer">
                                    <div className="col-12 sp-header-button-panel2">
                            
                                        { (stateObjAdjustment.status === 'DRAFT' 
                                        || stateObjAdjustment.status === 'WAITFAPP' 
                                        || stateObjAdjustment.status === 'REJECT'
                                        ) 
                                        &&<a className="sp-btn-icon" onClick={getDraftPDFFile}>
                                            <i className="icon btn-print-orange" />
                                            <span className="sp-btn-icon-label4">{stateObjAdjustment.status === 'COMPLETE' ? "Print": "Print Preview"}</span>
                                        </a>}

                                        { (stateObjAdjustment.status === 'COMPLETE') 
                                        &&<a className="sp-btn-icon" onClick={getDraftPDFFileComplete}>
                                            <i className="icon btn-print-orange" />
                                            <span className="sp-btn-icon-label4">{stateObjAdjustment.status === 'COMPLETE' ? "Print": "Print Preview"}</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === 'COMPLETE') 
                                        &&<a className="sp-btn-icon" onClick={editAdjustment}>
                                            <i className="icon btn-edit-blue" />
                                            <span className="sp-btn-icon-label">{"Edit"}</span>
                                        </a>}


                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === '' 
                                        || stateObjAdjustment.status === 'DRAFT'
                                        || stateObjAdjustment.status === 'REJECT') 
                                        &&<a className="sp-btn-icon" onClick={handleSave} style={{ cursor: 'pointer' }}>
                                            <i className="icon btn-order-savedraft"></i>
                                            <span className="sp-btn-icon-label">Save</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && (stateObjAdjustment.status === 'DRAFT'
                                        || stateObjAdjustment.status === 'REJECT') 
                                        && <a className="sp-btn-icon" onClick={handleOnClickSendConfirm}>
                                            <i className="icon btn-order-publish" />
                                            <span className="sp-btn-icon-label3">Submit</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && canApprove && stateObjAdjustment.status === 'WAITFAPP' && <a className="sp-btn-icon" onClick={handleOnClickApproveConfirm}>
                                            <i className="icon btn-order-approval" />
                                            <span className="sp-btn-icon-label3">Approve</span>
                                        </a>}

                                        { stateObjAdjustment.isReadonly === false && canApprove && stateObjAdjustment.status === 'WAITFAPP' && <a className="sp-btn-icon" onClick={handleOnClickRejectConfirm}>
                                            <i className="icon btn-order-reject" />
                                            <span className="sp-btn-icon-label2">Reject</span>
                                        </a>}

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <CustomDialog open={isOpenViewFile} title={stateObjAdjustment.status === 'COMPLETE' ? "Print หนังสือเกี่ยวข้องกับการปรับ" :"Print Preview หนังสือเกี่ยวข้องกับการปรับ"} maxWidth="sm"
                onClose={()=>{
                    setIsOpenViewFile(false)
                }}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} sm={6}>
                            <FormGroup>
                                { toBoolean(stateObjAdjustment.is_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintAdjust} onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintAdjust(true)
                                    }else{
                                        setIsPrintAdjust(false)
                                    }

                                }} />} label={stateObjAdjustment.product_type === "C" ? 'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ' : 'หนังสือแจ้งสิทธิ์เรียกค่าปรับ'} />}
                                { toBoolean(stateObjAdjustment.is_reserved_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintReservedAdjust}onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintReservedAdjust(true)
                                    }else{
                                        setIsPrintReservedAdjust(false)
                                    }

                                }} />} label="หนังสือแจ้งสงวนสิทธิ์การปรับ" />}
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickPreview}>
                                <i className="icon btn-order-check-green" />
                                <span className="sp-btn-icon-label">ยืนยัน</span>
                            </a>
                        </Grid>
                    </Grid>
                </CustomDialog>

                <CustomDialog open={isOpenViewFileComplete} title={stateObjAdjustment.status === 'COMPLETE' ? "Print หนังสือเกี่ยวข้องกับการปรับ" :"Print Preview หนังสือเกี่ยวข้องกับการปรับ"} maxWidth="sm"
                onClose={()=>{
                    setIsOpenViewFileComplete(false)
                }}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign:'center'}}>
                            <FormControl>
                                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" spacing={2}>
                                <Button color="primary" variant={hasPrintHeader ? "contained" :"outlined"} style={{marginRight:5}}><FormControlLabel value="header" style={{marginBottom:0}} control={<Radio style={{color: hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={hasPrintHeader}
                                    onChange={()=>{setHasPrintHeader(true)}}
                                    />} label="แบบมี Header/Footer" /></Button>
                                <Button color="primary" variant={!hasPrintHeader ? "contained" :"outlined"}><FormControlLabel value="noneheader" style={{marginBottom:0}} control={<Radio  style={{color: !hasPrintHeader ? '#ffffff' : '#3f51b5'}} checked={!hasPrintHeader}
                                    onChange={()=>{setHasPrintHeader(false)}}
                                    />} label="แบบไม่มี Header/Footer" /></Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <FormGroup>
                                { toBoolean(stateObjAdjustment.is_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintAdjust} onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintAdjust(true)
                                    }else{
                                        setIsPrintAdjust(false)
                                    }

                                }} />} label={stateObjAdjustment.product_type === "C" ? 'หนังสือแจ้งสงวนสิทธิ์เรียกค่าปรับ' : 'หนังสือแจ้งสิทธิ์เรียกค่าปรับ'} />}
                                { toBoolean(stateObjAdjustment.is_reserved_adjust) && <FormControlLabel control={<Checkbox color="primary" defaultValue={isPrintReservedAdjust}onChange={(event)=>{
                                    if(event.target.checked)
                                    {
                                        setIsPrintReservedAdjust(true)
                                    }else{
                                        setIsPrintReservedAdjust(false)
                                    }

                                }} />} label="หนังสือแจ้งสงวนสิทธิ์การปรับ" />}
                            </FormGroup>
                        </Grid>
                        <Grid item xs={12}>
                            <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickPreviewComplete}>
                                <i className="icon btn-order-check-green" />
                                <span className="sp-btn-icon-label">ยืนยัน</span>
                            </a>
                        </Grid>
                    </Grid>
                </CustomDialog>


                <CustomDialog open={isOpenConfirmSend} title="ยืนยันส่งอนุมัติ" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmSend(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยันส่งอนุมัติ</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickSend}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmSend(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>


                <CustomDialog open={isOpenConfirmApprove} title="ยืนยันอนุมัติ" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmApprove(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยันอนุมัติ</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickApprove}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmApprove(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>

                <CustomDialog open={isOpenEditAdjustment} title="ยืนยัน Edit" maxWidth="sm"
                onClose={()=>{
                    setIsOpenEditAdjustment(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center" spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <Typography align='center' variant="h6" component="h2">ยืนยัน Edit</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickEdit}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenEditAdjustment(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>


                

                <CustomDialog open={isOpenConfirmReject} title="Message" maxWidth="sm"
                onClose={()=>{
                    setIsOpenConfirmReject(false)
                }}
                >
                    
                    <Grid container style={{marginTop:20}} spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography align='right'>เหตุผล</Typography>
                        </Grid>
                        <Grid item xs={12} sm={7}>
                            <TextField
                             multiline
                             rows={4}
                             variant="outlined"
                             fullWidth
                             name="message_reject"
                             defaultValue={stateObjAdjustment.message_reject}
                             onBlur={handleChangeObjAdjustment}
                             helperText={stateObjAdjustment.message_reject ? "" : "กรุณาระบุเหตผล"}
                             error={!stateObjAdjustment.message_reject}
                             maxLength={250}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container   
                                justifyContent="center"
                                alignItems="center">
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={handleOnClickReject}>
                                        <i className="icon btn-order-check-green" />
                                        <span className="sp-btn-icon-label">ยืนยัน</span>
                                    </a>
                                </Grid>
                                <Grid item xs={2}>
                                    <a className="sp-btn-icon" style={{ cursor: 'pointer' }} onClick={()=>{setIsOpenConfirmReject(false)}}>
                                        <i className="icon btn-order-cancel" />
                                        <span className="sp-btn-icon-label">ยกเลิก</span>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CustomDialog>
            </div>
        
    );
}